export default Object.freeze({
  Reports: 174,
  User: 181,
});
